<div class="row">
  <div class="column">
    @if (gridOptions) {
      <div
        class="scrollable-flex-content"
        data-automation-id="lm-action-picker"
        soho-datagrid
        #actionPickerDataGridComponent
        [attr.id]="actionPickerDataGridComponent"
        [gridOptions]="gridOptions"
        (selected)="onRowSelected($event)"
      ></div>
    }
  </div>
</div>
